module.exports = __webpack_public_path__ + "img/icon_star_seller.70c6ada6.svg";